export { featuredAndSortedPortalsEpic } from './epic';
